import $ from 'jquery';
import Game from './fw/game';
import Flotsam from './flotsam';

function start(Game, Instruction) {
    var game = new Game();
    var instruction = new Instruction();
    game.ready(function () {
        document.body.innerHTML = "";
        game.load(instruction);
    });
}

$(document).ready(function () { start(Game, Flotsam); });
